var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('delivery-total',{attrs:{"lgSize":12,"lgOffset":0,"locParam":0}}),_c('delivery-total-courier',{attrs:{"lgSize":12,"lgOffset":0,"locParam":0}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }